import React, { useEffect, useRef, useState } from 'react';
import api from './setAxios';
import Cookies from 'js-cookie';

const POLL = ({ articleId }) => {
  const [fix, setFix] = useState(false);
  const commentRef = useRef(null);
  const [liked, setLiked] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      if (!isCommentVisible()) {
        setFix(true);
      } else {
        setFix(false);
      }
    };

    const isCommentVisible = () => {
      if (commentRef.current) {
        const rect = commentRef.current.getBoundingClientRect();
        return rect.top >= 0 && rect.bottom <= window.innerHeight;
      }
      return false;
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleLike = async (value) => {
        if (liked) return;

        const userId = Cookies.get('gid'); 

        try {
            const response = await api.post("/blogLike/LikeArticle", {
                ArticleId: articleId,
                GId: userId,
                Value: value
            });
            setLiked(true);
            setMessage('از بازخورد شما سپاسگزاریم! نظر شما برای ما بسیار ارزشمند است.');
        } catch (error) {
            console.error('Error liking the article:', error.response?.data);
            setMessage('Error occurred');
        }
    };

  return (
    <>
      <div className={fix ? 'poll fixed' : 'poll'}>
        <div className='poll-content'>
          
          {liked ? (
            <>
              <p>{message}</p>
              <i class="fa-solid fa-heart"></i>
            </>
          ) : (
            <>
            <p>آیا این مطلب مفید بوده است؟</p>
            <div className='poll-btn'>
              <input type="submit" id="submit-poll" className="btn ok-poll" value="بله" onClick={() => handleLike(1)} />
              <input type="submit" id="cancel-poll" className="btn no-poll" value="خیر" onClick={() => handleLike(-1)} />
            </div>
            </>
          )}
        </div>
      </div>
      <div className='frm-poll' ref={commentRef} ></div>
    </>
  );
};

export default POLL;
